import ApiValues from '../url/apiurl'
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
function getAddUpdateDeleteInsurance(data) {
    return Networking.PostApi(ApiValues.lifeInsuranceAddUpdateDelete, data).then(result => { return result })
        .catch(function (error) {
            return { "status": "F", "message": labels.messages.apierror }
        });
}
export default getAddUpdateDeleteInsurance